import { faCss3, faHtml5, faJs, faReact, faSass } from '@fortawesome/fontawesome-free-brands'
import { faB, faBookBookmark, faChalkboardUser, faPenNib, faStar, faT } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SiFirebase, SiRedux } from 'react-icons/si';
import './Skills.css'
import  { useEffect, useRef } from "react";
import lottie from "lottie-web";

function Skills() {
    const container = useRef(null);

    useEffect(() => {
        lottie.loadAnimation({
          container: container.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: require("../../../animation/Skills.json")
        });
    
        return () => {
          lottie.destroy();
        };
      }, []);
  return (
    <>
        <div className="skills" id='skills'>
            <div className="container">
                <h1 data-aos="zoom-in" data-aos-duration="2500">Skills</h1>
                <span><FontAwesomeIcon icon={faStar} /></span>
                <div className="info">
                <div className="container-skills">
                    
                <div className="left-skills">
                    <div className="box" >
                        <div className="icon">
                            <FontAwesomeIcon icon={faHtml5} />
                        </div>
                        <span>HTML5</span>
                    </div>
                    <div className="box" >
                    <div className="icon">
                            <FontAwesomeIcon icon={faCss3} />
                    </div>
                        <span>CSS3</span>
                    </div>
                    <div className="box" >
                    <div className="icon">
                        <FontAwesomeIcon icon={faJs} />
                    </div>
                        <span>JS(ES6)</span>
                    </div>
                    <div className="box" >
                    <div className="icon">
                        <FontAwesomeIcon icon={faT} />
                    </div>
                        <span>Tailwind CSS</span>
                    </div>
                    
                </div>
                <div className="right-skills">
                    <div className="box" >
                        <div className="icon">
                        <FontAwesomeIcon icon={faB} />
                        </div>
                        <span>Bootstrap</span>
                    </div>
                    <div className="box" >
                        <div className="icon">
                        <FontAwesomeIcon icon={faSass} />
                        </div>
                        <span>SASS</span>
                    </div>
                    <div className="box" >
                        <div className="icon">
                            <FontAwesomeIcon icon={faReact} />
                        </div>
                        <span>React</span>
                    </div>
                    <div className="box" >
                        <div className="icon">
                        <SiRedux className='special_svg_icon'  />
                        </div>
                        <span>Redux-Toolkit</span>
                    </div>





                </div>
                </div>
                </div>
                <span className='fact-2'>There Are No Limits</span>
                <div className="future">
                    
                    <div className='title'>
                        <FontAwesomeIcon icon={faChalkboardUser} />Under Studying ..
                    </div>
                </div>
                <div className='after-exp'>
                    <div className="left-skills">
                        <div className="box" >
                                <div className="icon">
                                <SiFirebase className='special_svg_icon' />
                                </div>
                                <span>Firebase</span>
                        </div>
                    </div>
                    {/* <div className="right-skills">
                        <div className="box sec" >
                            <div className="icon">
                            <FontAwesomeIcon icon={faT} />
                            </div>
                            <span>Tailwind Css</span>
                        </div>
                    </div>    */}
                </div>
                <div className="exp-edu">
                    <h2>Education <span>&</span> Experience</h2>
                    <div className="exp-container">
                        
                        <div className="box-left" data-aos="fade-right"
     data-aos-offset="200"
     data-aos-easing="ease-in-sine"
     data-aos-duration="1500">
                            <h3><FontAwesomeIcon icon={faBookBookmark} />Education</h3>
                            <div className="row-data">
                                <h4>Faculty of Computer and Information Science</h4>
                                <span>2018 — 2022</span>
                                <p>Bachelor OF Compuet And Information Science Mansoura University (Information Technology Departement)</p>
                            </div>
                            <div className="row-data">
                                <h4>Private Courses</h4>
                                <span>2022 — 2023</span>
                                <p>Study Private Courses for Front-end Developer in HTML, CSS, JavaScript, React.js ,Bootstrap and Sass</p>
                            </div>
                            <div className="row-data">
                                <h4>Self Learnings</h4>
                                <span>2023 — Until the end</span>
                                <div className="img" ref={container}></div>
                            </div>
                        </div>
                        <div className="box-right" data-aos="fade-left"
     data-aos-offset="200"
     data-aos-easing="ease-in-sine"
     data-aos-duration="1500">
                            <h3><FontAwesomeIcon icon={faPenNib} />Experience</h3>
                            <div className="row-data">
                                <h4>Freelancer</h4>
                                <span>2022 — 2023</span>
                                <p>I worked as a freelancer on several platforms, including khamsat and mostql, with sufficient experience to deal with others</p>
                            </div>
                            <div className="row-data">
                                <h4>Training Course in ITshare</h4>
                                <span> — 2022</span>
                                <p>A training course in ITshare and I created several projects using frontend languages (HTML, CSS, JS, BOOTSTRAP and REACT) , And I learned how to deal with Api's</p>
                            </div>
                            <div className="row-data">
                                <h4>Frontend Developer in Khattab Web Company</h4>
                                <span>2 Month</span>
                                <p>I worked at Khattab Web Company as a front end developer, and I created a website for Khairat Al-Rounah Company for cheese products in Saudi Arabia.</p>
                            </div>
                            <div className="row-data">
                                <h4>Certificates</h4>
                                <span> July - 2021  </span>
                                <p>ITI Certificate in Web Application Development Using PHP Framework (156 hrs.)</p>
                                <span>February - 2022  </span>
                                <p>Innovation camp acknowledgement</p>
                                <span> May - 2022  </span>
                                <p>Bachelor's degree in computers and information, Mansoura University, with a good grade</p>
                                <span> August - 2022  </span>
                                <p>UDACITY Certificate of Completed The Web Development Challenger Track</p>
                                <span> November - 2022  </span>
                                <p>IT SHARE Certificates in Front-end Diploma (80 hrs.)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </>
  )
}

export default Skills